import { effects as blockAttachmentEffects } from '@blocksuite/hive-block-attachment/effects';
import { effects as blockBookmarkEffects } from '@blocksuite/hive-block-bookmark/effects';
import { effects as blockCalloutEffects } from '@blocksuite/hive-block-callout/effects';
import { effects as blockCodeEffects } from '@blocksuite/hive-block-code/effects';
import { effects as blockDataViewEffects } from '@blocksuite/hive-block-data-view/effects';
import { effects as blockDatabaseEffects } from '@blocksuite/hive-block-database/effects';
import { effects as blockDividerEffects } from '@blocksuite/hive-block-divider/effects';
import { effects as blockEdgelessTextEffects } from '@blocksuite/hive-block-edgeless-text/effects';
import { effects as blockEmbedEffects } from '@blocksuite/hive-block-embed/effects';
import { effects as blockFrameEffects } from '@blocksuite/hive-block-frame/effects';
import { effects as blockImageEffects } from '@blocksuite/hive-block-image/effects';
import { effects as blockLatexEffects } from '@blocksuite/hive-block-latex/effects';
import { effects as blockListEffects } from '@blocksuite/hive-block-list/effects';
import { effects as blockNoteEffects } from '@blocksuite/hive-block-note/effects';
import { effects as blockParagraphEffects } from '@blocksuite/hive-block-paragraph/effects';
import { effects as blockRootEffects } from '@blocksuite/hive-block-root/effects';
import { effects as blockSurfaceEffects } from '@blocksuite/hive-block-surface/effects';
import { effects as blockSurfaceRefEffects } from '@blocksuite/hive-block-surface-ref/effects';
import { effects as blockTableEffects } from '@blocksuite/hive-block-table/effects';
import { BlockSelection } from '@blocksuite/hive-components/block-selection';
import { BlockZeroWidth } from '@blocksuite/hive-components/block-zero-width';
import { effects as componentCaptionEffects } from '@blocksuite/hive-components/caption';
import { effects as componentCardStyleDropdownMenuEffects } from '@blocksuite/hive-components/card-style-dropdown-menu';
import { effects as componentColorPickerEffects } from '@blocksuite/hive-components/color-picker';
import { effects as componentContextMenuEffects } from '@blocksuite/hive-components/context-menu';
import { effects as componentDatePickerEffects } from '@blocksuite/hive-components/date-picker';
import { effects as componentDropIndicatorEffects } from '@blocksuite/hive-components/drop-indicator';
import { effects as componentEdgelessLineStylesEffects } from '@blocksuite/hive-components/edgeless-line-styles-panel';
import { effects as componentEdgelessLineWidthEffects } from '@blocksuite/hive-components/edgeless-line-width-panel';
import { effects as componentEdgelessShapeColorPickerEffects } from '@blocksuite/hive-components/edgeless-shape-color-picker';
import { effects as componentEmbedCardModalEffects } from '@blocksuite/hive-components/embed-card-modal';
import { FilterableListComponent } from '@blocksuite/hive-components/filterable-list';
import { effects as componentHighlightDropdownMenuEffects } from '@blocksuite/hive-components/highlight-dropdown-menu';
import { IconButton } from '@blocksuite/hive-components/icon-button';
import { effects as componentLinkPreviewEffects } from '@blocksuite/hive-components/link-preview';
import { effects as componentLinkedDocTitleEffects } from '@blocksuite/hive-components/linked-doc-title';
import { effects as componentOpenDocDropdownMenuEffects } from '@blocksuite/hive-components/open-doc-dropdown-menu';
import { effects as componentPortalEffects } from '@blocksuite/hive-components/portal';
import { effects as componentSizeDropdownMenuEffects } from '@blocksuite/hive-components/size-dropdown-menu';
import { SmoothCorner } from '@blocksuite/hive-components/smooth-corner';
import { effects as componentToggleButtonEffects } from '@blocksuite/hive-components/toggle-button';
import { ToggleSwitch } from '@blocksuite/hive-components/toggle-switch';
import { effects as componentToolbarEffects } from '@blocksuite/hive-components/toolbar';
import { effects as componentTooltipContentWithShortcutEffects } from '@blocksuite/hive-components/tooltip-content-with-shortcut';
import { effects as componentViewDropdownMenuEffects } from '@blocksuite/hive-components/view-dropdown-menu';
import { effects as fragmentDocTitleEffects } from '@blocksuite/hive-fragment-doc-title/effects';
import { effects as fragmentFramePanelEffects } from '@blocksuite/hive-fragment-frame-panel/effects';
import { effects as fragmentOutlineEffects } from '@blocksuite/hive-fragment-outline/effects';
import { effects as inlineFootnoteEffects } from '@blocksuite/hive-inline-footnote/effects';
import { effects as inlineLatexEffects } from '@blocksuite/hive-inline-latex/effects';
import { effects as inlineLinkEffects } from '@blocksuite/hive-inline-link/effects';
import { effects as inlineMentionEffects } from '@blocksuite/hive-inline-mention';
import { effects as inlinePresetEffects } from '@blocksuite/hive-inline-preset/effects';
import { effects as inlineReferenceEffects } from '@blocksuite/hive-inline-reference/effects';
import { effects as richTextEffects } from '@blocksuite/hive-rich-text/effects';
import { effects as widgetDragHandleEffects } from '@blocksuite/hive-widget-drag-handle/effects';
import { effects as widgetEdgelessAutoConnectEffects } from '@blocksuite/hive-widget-edgeless-auto-connect/effects';
import { effects as widgetFrameTitleEffects } from '@blocksuite/hive-widget-frame-title/effects';
import { effects as widgetRemoteSelectionEffects } from '@blocksuite/hive-widget-remote-selection/effects';
import { effects as widgetScrollAnchoringEffects } from '@blocksuite/hive-widget-scroll-anchoring/effects';
import { effects as widgetSlashMenuEffects } from '@blocksuite/hive-widget-slash-menu/effects';
import { effects as widgetToolbarEffects } from '@blocksuite/hive-widget-toolbar/effects';
import { effects as dataViewEffects } from '@blocksuite/data-view/effects';
import { effects as stdEffects } from '@blocksuite/std/effects';

import { registerBlockSpecs } from './extensions';

export declare const _GLOBAL_:
  | typeof stdEffects
  | typeof dataViewEffects
  | typeof richTextEffects
  | typeof blockNoteEffects
  | typeof blockAttachmentEffects
  | typeof blockBookmarkEffects
  | typeof blockFrameEffects
  | typeof blockListEffects
  | typeof blockParagraphEffects
  | typeof blockEmbedEffects
  | typeof blockSurfaceEffects
  | typeof blockImageEffects
  | typeof blockDatabaseEffects
  | typeof blockSurfaceRefEffects
  | typeof blockLatexEffects
  | typeof blockEdgelessTextEffects
  | typeof blockDividerEffects
  | typeof blockDataViewEffects
  | typeof blockCodeEffects
  | typeof blockTableEffects
  | typeof blockRootEffects
  | typeof blockCalloutEffects
  | typeof componentCaptionEffects
  | typeof componentContextMenuEffects
  | typeof componentDatePickerEffects
  | typeof componentDropIndicatorEffects
  | typeof componentEmbedCardModalEffects
  | typeof componentHighlightDropdownMenuEffects
  | typeof componentLinkPreviewEffects
  | typeof componentLinkedDocTitleEffects
  | typeof componentPortalEffects
  | typeof componentToolbarEffects
  | typeof componentToggleButtonEffects
  | typeof componentColorPickerEffects
  | typeof componentViewDropdownMenuEffects
  | typeof widgetScrollAnchoringEffects
  | typeof widgetFrameTitleEffects
  | typeof widgetRemoteSelectionEffects
  | typeof widgetDragHandleEffects
  | typeof widgetEdgelessAutoConnectEffects
  | typeof widgetToolbarEffects
  | typeof widgetSlashMenuEffects
  | typeof fragmentDocTitleEffects
  | typeof fragmentFramePanelEffects
  | typeof fragmentOutlineEffects;

export function effects() {
  registerBlockSpecs();
  stdEffects();

  dataViewEffects();
  richTextEffects();

  inlineReferenceEffects();
  inlinePresetEffects();
  inlineLinkEffects();
  inlineFootnoteEffects();
  inlineLatexEffects();
  inlineMentionEffects();

  blockNoteEffects();
  blockAttachmentEffects();
  blockBookmarkEffects();
  blockFrameEffects();
  blockListEffects();
  blockParagraphEffects();
  blockEmbedEffects();
  blockSurfaceEffects();
  blockImageEffects();
  blockDatabaseEffects();
  blockSurfaceRefEffects();
  blockLatexEffects();
  blockEdgelessTextEffects();
  blockDividerEffects();
  blockDataViewEffects();
  blockCodeEffects();
  blockTableEffects();
  blockRootEffects();
  blockCalloutEffects();

  componentCaptionEffects();
  componentContextMenuEffects();
  componentDatePickerEffects();
  componentPortalEffects();
  componentToolbarEffects();
  componentDropIndicatorEffects();
  componentToggleButtonEffects();
  componentColorPickerEffects();
  componentEmbedCardModalEffects();
  componentLinkPreviewEffects();
  componentLinkedDocTitleEffects();
  componentCardStyleDropdownMenuEffects();
  componentHighlightDropdownMenuEffects();
  componentViewDropdownMenuEffects();
  componentTooltipContentWithShortcutEffects();
  componentSizeDropdownMenuEffects();
  componentEdgelessLineWidthEffects();
  componentEdgelessLineStylesEffects();
  componentEdgelessShapeColorPickerEffects();
  componentOpenDocDropdownMenuEffects();

  widgetScrollAnchoringEffects();
  widgetFrameTitleEffects();
  widgetRemoteSelectionEffects();
  widgetDragHandleEffects();
  widgetEdgelessAutoConnectEffects();
  widgetSlashMenuEffects();
  widgetToolbarEffects();

  fragmentDocTitleEffects();
  fragmentFramePanelEffects();
  fragmentOutlineEffects();

  customElements.define('icon-button', IconButton);
  customElements.define('smooth-corner', SmoothCorner);
  customElements.define('toggle-switch', ToggleSwitch);
  customElements.define('hive-filterable-list', FilterableListComponent);
  customElements.define('block-zero-width', BlockZeroWidth);
  customElements.define('hive-block-selection', BlockSelection);
}
